// BfnFilters.jsx
import React from 'react';
import './StatisticaBFN.css';

const BfnFilters = ({
    years,
    distr,
    selYear,
    selDist,
    selPeriod,
    periods,
    onYearChange,
    onDistrictChange,
    onPeriodChange,
    onShowData
}) => {
    return (
        <div className="filter-row">
            <div className="row">
                <div className="col-md-3 filter-section">
                    <label className="filter-label">Навчальний рік:</label>
                    <select 
                        className="filter-select" 
                        value={selYear} 
                        onChange={onYearChange}
                    >
                        {years.map((elem, index) => (
                            <option key={index} value={`${elem._id}:${index}`}>
                                {elem._id}/{elem._id+1}
                            </option>
                        ))}
                        <option value="history">На період</option>
                    </select>
                </div>

                <div className="col-md-3 filter-section">
                    <label className="filter-label">Збережено за:</label>
                    <select 
                        className="filter-select" 
                        disabled={selYear !== 'history'} 
                        value={selPeriod} 
                        onChange={onPeriodChange}
                    >
                        {periods.map((p, i) => (
                            <option key={i} value={i}>{p}</option>
                        ))}
                    </select>
                </div>

                <div className="col-md-3 filter-section">
                    <label className="filter-label">Район:</label>
                    <select 
                        className="filter-select" 
                        value={selDist} 
                        onChange={onDistrictChange}
                    >
                        {distr.map((dist, index) => (
                            <option key={index} value={dist}>{dist}</option>
                        ))}
                        <option value='all'>всі райони</option>
                    </select>
                </div>
                
                <div className="col-md-3 filter-section">
                    <label className="filter-label">&nbsp;</label>
                    <button className="filter-button" onClick={onShowData}>
                        Показати
                    </button>
                </div>
            </div>
        </div>
    );
};

export default BfnFilters;